import { render, staticRenderFns } from "./Debatedetails.vue?vue&type=template&id=165a4301&"
import script from "./Debatedetails.vue?vue&type=script&lang=js&"
export * from "./Debatedetails.vue?vue&type=script&lang=js&"
import style0 from "./Debatedetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports